import { formatDateMoment, setCurrency, setNumberWithPoint } from 'utils/utils'
import clsx from 'clsx'
import icArrowUp from 'assets/images/ic-arrow-up.svg'
import icArrowDown from 'assets/images/ic-arrow-down-red.svg'

const CardComparison = ({ className, title, name, isCurrency, dataComparison }) => {
    const state = dataComparison?.percentage?.[name]?.state
    const value = dataComparison?.percentage?.[name]?.value
    const currentPeriod = dataComparison?.current_period
    const previousPeriod = dataComparison?.previous_period

    const getDataPercentage = (trend, value) => {
        let icon = ''
        let text = ''
        let percentage = ''
        let className = ''

        switch (trend) {
            case 'up':
                icon = icArrowUp
                text = 'Naik'
                percentage = `${value?.toFixed(2)}%`
                className = 'text-[#748D6F]'
                break
            case 'down':
                icon = icArrowDown
                text = 'Turun'
                percentage = `${value?.toFixed(2)}%`
                className = 'text-red-60'
                break
            case 'constant':
                text = 'Konstan'
                className = 'text-neutral-60'
                break
            default:
                return 0
        }

        return { icon, text, percentage, className }
    }

    return (
        <div className={clsx('border border-neutral-20', className)}>
            <p className={'font-bold text-center bg-blue-5 py-2'}>{title}</p>
            <div className={'flex justify-between py-3 px-5'}>
                <div className={`flex items-center space-x-1 basis-1/5 ${getDataPercentage(state)?.className}`}>
                    {getDataPercentage(state)?.icon && <img src={getDataPercentage(state)?.icon} alt='ic-arrow' />}
                    <div>
                        <p>{getDataPercentage(state)?.text}</p>
                        <p>{getDataPercentage(state, value)?.percentage}</p>
                    </div>
                </div>
                <div className={'flex flex-col space-y-3 pl-4 basis-2/5 border-l border-neutral-20'}>
                    <p className={'font-semibold'}>Periode Saat Ini</p>
                    <p className={'text-lg font-bold'}>
                        {isCurrency ? setCurrency(currentPeriod?.[name]) : setNumberWithPoint(currentPeriod?.[name])}
                    </p>
                    <p className={'text-neutral-60'}>
                        {formatDateMoment(currentPeriod?.start_date, 'DD MMM YY')} -{' '}
                        {formatDateMoment(currentPeriod?.end_date, 'DD MMM YY')}
                    </p>
                </div>
                <div className={'flex flex-col space-y-3 pl-4 basis-2/5 border-l border-neutral-20'}>
                    <p className={'font-semibold'}>Periode Sebelumnya</p>
                    <p className={'text-lg font-bold'}>
                        {isCurrency ? setCurrency(previousPeriod?.[name]) : setNumberWithPoint(previousPeriod?.[name])}
                    </p>
                    <p className={'text-neutral-60'}>
                        {formatDateMoment(previousPeriod?.start_date, 'DD MMM YY')} -{' '}
                        {formatDateMoment(previousPeriod?.end_date, 'DD MMM YY')}
                    </p>
                </div>
            </div>
        </div>
    )
}

export default CardComparison
